<template>
  <div class="row">
    <div class="col-md-12">
      <div class="change-avatar">
        <p
          class="text-center"
          v-viewer
        >
          <img
            :src="imgDataUrl"
            @error="(e) => {e.target.src='/img/take_photo_with_id.jpg'}"
            class="img-responsive"
            alt="Selfie Photo"
          >
        </p>
      </div>
    </div>
    <div class="col-md-12">
      <div
        class="btn-upload"
        @click="toggleShow"
      >
        {{ $t('label.uploadNewPhotoHoldingTheNationalId') }}
      </div>
    </div>
    <my-upload
      field="borrower_photo"
      @crop-success="cropSuccess"
      @crop-upload-success="cropUploadSuccess"
      @crop-upload-fail="cropUploadFail"
      v-model="show"
      :width="300"
      :lang-type="langType"
      :lang-ext="locale"
      :height="300"
      :url="`${apiUrl}/api/v1/borrows/upload-photo`"
      :params="params"
      :headers="headers"
      img-format="png"
    />
  </div>
</template>

<script>
import 'babel-polyfill'
import myUpload from 'vue-image-crop-upload'

export default {
  name: 'UploadPhoto',
  props: {
    borrow: {
      type: Object,
      required: true
    }
  },
  components: {
    'my-upload': myUpload
  },
  data () {
    return {
      apiUrl: process.env.VUE_APP_API,
      show: false,
      params: {
        id: null,
        name: 'borrower_photo'
      },
      imgDataUrl: null,
      headers: null,
      locales: {
        en: {
          hint: 'Click or drag the file here to uploaded',
          loading: 'Uploading…',
          noSupported: 'Browser is not supported, please use IE10+ or other browsers',
          success: 'Upload success',
          fail: 'Upload failed',
          preview: 'Preview',
          btn: {
            off: 'Cancel',
            close: 'Close',
            back: 'Back',
            save: 'Save'
          },
          error: {
            onlyImg: 'Image only',
            outOfSize: 'Image exceeds size limit: ',
            lowestPx: 'Image\'s size is too low. Expected at least: '
          }
        },
        km: {
          hint: 'ចុចឬអូសឯកសារនៅទីនេះដើម្បីផ្ទុកឡើង',
          loading: 'កំពុងផ្ទុកឡើង ...',
          noSupported: 'កម្មវិធីរុករកមិនត្រូវបានគាំទ្រសូមប្រើ IE10 + ឬកម្មវិធីរុករកផ្សេងទៀត',
          success: 'អាប់ឡូតជោគជ័យ',
          fail: 'ផ្ទុកឡើងបានបរាជ័យ',
          preview: 'មើលជាមុន',
          btn: {
            off: 'បោះបង់',
            close: 'បិទ',
            back: 'ថយក្រោយ',
            save: 'រក្សាទុក'
          },
          error: {
            onlyImg: 'រូបភាពតែប៉ុណ្ណោះ',
            outOfSize: 'រូបភាពលើសពីដែនកំណត់ទំហំ: ',
            lowestPx: 'ទំហំរូបភាពគឺទាបពេក។ បានរំពឹងថាយ៉ាងហោចណាស់: '
          }
        }
      }
    }
  },
  computed: {
    langType () {
      return this.$i18n.locale
    },
    locale () {
      if (this.$i18n.locale === 'km') {
        return this.locales.km
      }
      return this.locales.en
    }
  },
  watch: {
    borrow () {
      if (this.borrow) {
        this.params.id = this.borrow.id
        if (this.borrow.borrower_photo) {
          this.imgDataUrl = `${this.apiUrl}/${this.borrow.borrower_photo}`
        } else {
          this.imgDataUrl = `${this.apiUrl}/img/tmp-default.png`
        }
      }
    }
  },
  methods: {
    toggleShow () {
      this.show = !this.show
    },
    cropSuccess (imgDataUrl, field) {
    },
    cropUploadSuccess (jsonData) {
      this.imgDataUrl = this.apiUrl + '/' + jsonData.data.borrower_photo
    },
    cropUploadFail (status, field) {}
  },
  mounted () {
    const token = localStorage.getItem(process.env.VUE_APP_TOKEN)

    this.headers = {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json'
    }
  }
}
</script>

<style scoped>
.change-avatar {
  align-content: center;
  text-align: center;
  border: 1px solid #d2d6de;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  padding: 30px;
  cursor: pointer;
}

.btn-upload {
  text-align: center;
  padding: 15px;
  background-color: #d2d6de;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  margin-bottom: 20px;
  cursor: pointer;
}
</style>
